module.exports = __webpack_public_path__ + "static/media/izlozba (2).9fd39a7c.jpg";